import styled from '@emotion/styled'

import { breakpoints, spacing, Text, typography } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${spacing.majorScale(3)}px;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(3)}px;

    @media (min-width: ${breakpoints.lg}px) {
      margin-right: ${spacing.majorScale(12)}px;
    }
  }

  > * {
    flex-grow: 1;
  }

  @media (min-width: ${breakpoints.lg}px) {
    > * {
      flex-grow: 0;
    }
  }
`

export const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${spacing.majorScale(2)}px;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(1)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;

    > :not(:last-child) {
      margin-right: ${spacing.majorScale(6)}px;
      margin-bottom: 0;
    }
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(1)}px;
  }
`

export const GroupTitle = styled(Text)`
  font-size: 14px;
  font-weight: ${typography.fontWeight.bold};
`
